import React from "react";
import Icon from "@ant-design/icons";

const ImageUploadThumbnailIconSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		{/* <g clip-path="url(#clip0_3607_37146)"> */}
		<g clipPath="url(#clip0_3607_37146)">
			<path
				d="M47.75 33.75V40.5H54.5V45H47.75V51.75H43.25V45H36.5V40.5H43.25V33.75H47.75ZM47.768 6.75C49.001 6.75 50 7.75125 50 8.98425V30.0195C48.5547 29.509 47.0328 29.2487 45.5 29.25V11.25H9.5L9.50225 42.75L30.4093 21.8407C30.7962 21.4526 31.3115 21.2191 31.8585 21.1843C32.4054 21.1495 32.9463 21.3158 33.3792 21.6518L33.5907 21.843L41.567 29.8305C39.8224 30.3621 38.2036 31.2415 36.8081 32.4157C35.4126 33.5898 34.2694 35.0344 33.4473 36.6624C32.6252 38.2904 32.1414 40.068 32.0249 41.888C31.9084 43.708 32.1617 45.5328 32.7695 47.2523L7.232 47.25C6.63983 47.2494 6.07212 47.0137 5.6536 46.5948C5.23508 46.1759 5 45.6079 5 45.0158V8.98425C5.00412 8.39335 5.24053 7.82779 5.65815 7.40974C6.07578 6.99169 6.64111 6.75471 7.232 6.75H47.768ZM18.5 15.75C19.6935 15.75 20.8381 16.2241 21.682 17.068C22.5259 17.9119 23 19.0565 23 20.25C23 21.4435 22.5259 22.5881 21.682 23.432C20.8381 24.2759 19.6935 24.75 18.5 24.75C17.3065 24.75 16.1619 24.2759 15.318 23.432C14.4741 22.5881 14 21.4435 14 20.25C14 19.0565 14.4741 17.9119 15.318 17.068C16.1619 16.2241 17.3065 15.75 18.5 15.75Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_3607_37146">
				<rect
					width={width}
					height={height}
					fill="white"
					transform="translate(0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const ImageUploadThumbnailIcon = (props) => (
	<Icon component={() => <ImageUploadThumbnailIconSvg {...props} />} />
);

export default ImageUploadThumbnailIcon;
